import { NgModule } from '@angular/core';

import { CollectionFormComponent } from './collection-form.component';
import { SharedModule } from '../../shared/shared.module';
import { ComcolModule } from '../../shared/comcol/comcol.module';
import { FormModule } from '../../shared/form/form.module';
import { ThemedCollectionFormComponent } from './themed-collection-form.component';

@NgModule({
  imports: [
    ComcolModule,
    FormModule,
    SharedModule
  ],
  declarations: [
    CollectionFormComponent,
    ThemedCollectionFormComponent,
  ],
  exports: [
    CollectionFormComponent,
    ThemedCollectionFormComponent,
  ]
})
export class CollectionFormModule {

}
